var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96331 10.2479C5.96959 10.4676 6.0512 10.656 6.2207 10.8255L11.1049 15.603C11.2493 15.7411 11.4188 15.8164 11.626 15.8164C12.0466 15.8164 12.373 15.49 12.373 15.0693C12.373 14.8684 12.2914 14.6801 12.147 14.5357L7.75251 10.2479L12.147 5.9601C12.2914 5.81571 12.373 5.63365 12.373 5.42648C12.373 5.00586 12.0466 4.67941 11.626 4.67941C11.4251 4.67941 11.2493 4.75474 11.1049 4.89286L6.2207 9.67662C6.04492 9.83984 5.96331 10.0282 5.96331 10.2479Z",
    fill: "#8592A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.c3cf10732cdcf5deb9d18f24ade830e6.svg";
export { ForwardRef as ReactComponent };